import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { setupNetdataGroup } from "./netdata";

const NetdataSetupEn = await fetch(require("./tutorial/setup/en.md")).then(
  (res) => res.text()
);
const NetdataSetupDe = await fetch(require("./tutorial/setup/de.md")).then(
  (res) => res.text()
);

// Fresh section per catalog build - see network/section.ts for the rationale.
export const netdataScanners = (): Section => {
  const netdataScanners = new Section("netdata_scanner", [
    new Translation("en", "Netdata Scanners"),
    new Translation("en", "Netdata-Scanner"),
  ]);
  netdataScanners.help = [
    new Translation(
      "en",
      `Add Netdata to get more detailed information about their API!`
    ),
    new Translation(
      "de",
      `Fügen Sie Netdata hinzu, um detailliertere Informationen über deren API zu erhalten!`
    ),
  ];

  netdataScanners.description = [
    new Translation("en", NetdataSetupEn),
    new Translation("de", NetdataSetupDe),
  ];

  setupNetdataGroup(netdataScanners, 0);
  return netdataScanners;
};
